<template>
  <div id="app">
    <HeadComponent />
    <router-view></router-view>
    <StorysComponent />
    <FooterComponent />
  </div>
</template>

<script>
// @ is an alias to /src
import HeadComponent from '@/components/Header.vue';
import StorysComponent from '@/components/Storys.vue';
import FooterComponent from '@/components/Footer.vue';

export default {
  components: {
    HeadComponent,
    StorysComponent,
    FooterComponent,
  },
  methods: {
  },
};
</script>

<style lang="css">
@import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap&subset=latin-ext');
@import url("https://fonts.googleapis.com/css?family=Old+Standard+TT&display=swap");

body {
  margin: 0px;
  padding: 0px;
  background-color: #151726;
  color: #fff;
  background-image: url("./assets/img/bg-pattern.jpg");
  background-size: 100% auto;
  background-repeat: repeat-y;
  font-family: 'Montserrat', sans-serif;
}
.container {
  max-width: 1366px;
  width: 100%;
  margin: 0 auto;
}
.whtbg {
  background-color: #fff;
}
@media screen and (max-width: 1400px) {
  .container {
    max-width: initial;
    width: calc(100% - 40px);
    padding: 0 20px;
  }
}
</style>
